export const multiLineTextToArray = (text) => {
  const arrayValues = text.split('\n');
  const trimmedValues = arrayValues.map((val) => val.trim());
  const stringValues = trimmedValues.filter(String);
  return [...new Set(stringValues)]; // Return unique values
};

export const longestString = (array) => {
  let maxValue = '';

  for (const value of array) {
    if (value.length > maxValue.length) {
      maxValue = value;
    }
  }

  return maxValue;
};

export const arrayToText = (value) => {
  const coercedArray = [].concat(value);
  return coercedArray.join('\n');
};
